import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {TOTO_CATEGORY_FILTER_BUTTONS_DATA,} from "../constants/component_constants";
import {getGameLogoImgURL,} from "../utils/componentUtils";
import {accountInfo, PERMISSION_LIST, SET_MONEY_BUTTON_LIST} from "../constants/constants";
import TotoGameCard from "../components/card/TotoGameCard";
import {GET_TOTO_GAME_INFO_API} from "../constants/api_constants";
import {getFetcherEB} from "../utils/fetcher_eb";
import TotoCartSidebar from "../components/TotoCartSidebar";
import neverLandUtils from "../utils/NeverLandUtils";
import useInactivityTimer from "../utils/useInactivityTimer";


const TotoGamePage = () => {
  const [categoryOption, setCategoryOptionOption] = useState("sc");
  const [subMenuList, setSubMenuList] = useState([]);
  const [selectedSubMenuOption, setSelectedSubMenuOption] = useState({name: "", value: ""});
  const [totoGameList, setTotoGameList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [gameStatus, setGameStatus] = useState('발매종료');
  const [gameStatusMap, setGameStatusMap] = useState({}); // 각 메뉴별 상태 저장
  const thisYear = new Date().getFullYear();
  const selectedSubMenuOptionRef = useRef(selectedSubMenuOption);
  const hasPermission = neverLandUtils.usePermission();

  // 5분동안 이벤트 감지 없으면 프로토 페이지로 이동
  useInactivityTimer(300000);
  
  useEffect(() => {
    // 처음 호출
    getTotoGameInfo();

    // 60초마다 호출
    const intervalId = setInterval(() => {
      getTotoGameInfo();
    }, 60000);

    // 언마운트하면 중지
    return () => {
      clearInterval(intervalId);
    }
  }, [categoryOption]);

  useEffect(() => {
    if (subMenuList.length > 0 && totoGameList.length > 0) {
      const statusMap = {};
      subMenuList.forEach(menu => {
        statusMap[menu.value] = getGameStatus(menu.value);
      });
      setGameStatusMap(statusMap);
      // console.log("📊 전체 메뉴 상태 업데이트:", statusMap);
    }
  }, [subMenuList, totoGameList]);

  useEffect(() => {
    // selectedSubMenuOption 변경될 때마다 ref 업데이트 (빈 값 포함 항상 갱신)
    selectedSubMenuOptionRef.current = selectedSubMenuOption.value;
    if (selectedSubMenuOption.value) {
      let _status = getGameStatus(selectedSubMenuOption.value);
      setGameStatus(_status);
    }
  }, [selectedSubMenuOption]);

  const getGameStatus = useCallback((categoryCode) => {
    // '발매중' | '발매마감' | '경기종료' 상태 관리
    const categoryGames = totoGameList.filter(item => item.categoryCode === categoryCode);

    if (categoryGames.length === 0) return '발매마감';

    // 모든 게임이 경기종료 인지 확인 -> 경기종료
    if (categoryGames.every(game => game.state === '경기종료')) {
      return '경기종료';
    }

    // 발매 마감 시간 체크
    const closingDateStr = categoryGames[0]?.closingDate;
    if (closingDateStr) {
      const endTimeStr = closingDateStr.split(' ~ ')[1];
      const endTime = new Date(endTimeStr);
      const now = new Date();

      // console.log("🧁 경기코드 : ,", categoryGames[0]?.categoryCode,"종료시간:", endTime);
      return now < endTime ? '발매중' : '발매마감';
    }
    return '발매마감';
  }, [totoGameList]);

  const getRoundNumber = () => {
    if (selectedSubMenuOption && selectedSubMenuOption.name) {
      const name = selectedSubMenuOption.name;
      const yearMatch = name.match(/(\d{4})년도/);
      const roundMatch = name.match(/(\d+)회차/);
      if (yearMatch && roundMatch) {
        const year = yearMatch[1].slice(2);
        const round = roundMatch[1].padStart(4, '0');
        return parseInt(year + round);
      }
    }
    return 0;
  }

  const getTotoGameInfo = () => {
    // 토토 경기정보 가져오기
    getFetcherEB().get(GET_TOTO_GAME_INFO_API + `?systemkey=wiztoto&year=${thisYear}&category=${categoryOption}`)
      .then(res => {
        const {memuList, contents} = res.data.result.gameTotoList.data;
        if (res.status === 200) {
          setTotoGameList(contents);
          setSubMenuList(memuList);
          setIsLoading(false);

          // 현재 선택된 메뉴가 없으면 첫 번째 메뉴로 설정
          const isCurrentMenuInList = memuList.some(menu => menu.value === selectedSubMenuOptionRef.current);

          if (!isCurrentMenuInList) {
            setSelectedSubMenuOption(memuList[0] || {name: "", value: ""});
          }
        } else {
          console.log('정보 불러오기 실패', res.data);
        }
      }).catch(err => {
      console.log(err)
    })
  }

  function getCategoryTitle(name) {
    // 토토 경기구분 + 회차 가져오기
    if (name.length < 10)
      return name;
    let tokens = name.split(' ');
    if (tokens.length > 3)
      return tokens[1] + ' ' + tokens[3];
    return name.substring(0, 9) + '...';
  }

  if (isLoading) {
    return (<p> 정보를 가져오는 중입니다. </p>)
  }
  return (
    <div
      className="w-full h-[calc(100%-2rem)] flex flex-col items-center justify-center">
      {/* <------------ 상단 카테고리 버튼 ------------> */}
      <div
        className={`${accountInfo.isDarkMode() ? "text-white" : ""} w-full h-[3.5rem] flex flex-row font-bold pb-2 whitespace-nowrap items-center justify-center`}>
        {TOTO_CATEGORY_FILTER_BUTTONS_DATA.map((item, index) => {
          return (
            <div key={index} className="flex flex-col items-center">
              <button
                className={`${categoryOption === item.value ? (accountInfo.isDarkMode() ? "text-gray-900 bg-white" : "text-white bg-gray-900") + " rounded-full" : ""} 
                        text-lg px-7 mx-6 py-1`}
                onClick={() => setCategoryOptionOption(item.value)}
              >
                {item.name}
              </button>
            </div>
          )
        })}
      </div>

      <div className="w-[62rem] h-[calc(100%-3rem)] flex flex-row justify-between items-center">
        {/* <------------ 경기정보(게임카드) 영역 ------------> */}
        <div className="w-[43rem] h-full overflow-y-auto py-3 mr-2 pr-2">
          {subMenuList.length === 0 && totoGameList.length === 0 ? (
            <div className="w-full h-full flex items-center justify-center">
              <p className={`text-xl font-bold ${accountInfo.isDarkMode() ? "text-gray-400" : "text-gray-500"}`}>
                진행중인 경기 정보가 없습니다.
              </p>
            </div>
          ) : (
            <TotoGameCard totoGameList={totoGameList} selectedSubMenuOption={selectedSubMenuOption}
                          gameStatus={gameStatus}/>
          )}
        </div>

        <div className="w-[23rem] h-full flex flex-col items-start">
          {/* <------------ 서브메뉴 ------------> */}
          <div
            className={`${accountInfo.isDarkMode() ? "text-white" : ""} w-full flex flex-col font-bold mt-3`}>
            {subMenuList?.map((subItem, subIndex) => {
              const status = gameStatusMap[subItem.value] || '발매마감';
              return (
                <button
                  key={subIndex}
                  className={`${selectedSubMenuOption.value === subItem.value ? "text-amber-900 border-amber-500 border-4" : "text-gray-900 border border-gray-200"} 
                      w-full h-16 rounded-lg text-lg mb-4 shadow-md flex flex-row justify-start items-center pl-5 
                             ${status === '발매중' ? "bg-white" : "bg-gray-500"}`}
                  onClick={() => setSelectedSubMenuOption(subItem)}
                >
                  <img src={getGameLogoImgURL(categoryOption)} className="h-7 w-7 mr-2"/>

                  <div className="flex flex-col justify-start items-start ml-2">
                    <p>{getCategoryTitle(subItem.name)}</p>
                    {/*<p className="text-sm text-red-600">마감 1일전</p>*/}
                  </div>
                </button>
              )
            })}
          </div>

          {/* <------------ 카트사이드바 영역 ------------> */}
          <div className="w-full">
            {/* MEMO: 축구 승무패 && 지점 권한 리스트에 코드 있을 때만 띄우기*/}

            {selectedSubMenuOption.value === 'sc1' && hasPermission('TOTO_SC_WDL') &&
              <TotoCartSidebar totoGameList={totoGameList} selectedSubMenuOption={selectedSubMenuOption}
                               gameStatus={gameStatus}  categoryOption={categoryOption} getRoundNumber={getRoundNumber()}
              />
            }
          </div>
        </div>

      </div>
    </div>
  );
}
export default TotoGamePage;
